const categoryEn = [
  'Legal Services',
  'Accounting and Taxation',
  'Intellectual Property',
  'Financial Services',
  'Cross-border Trade Dispute Support (Legal Advice) Pilot Scheme (1-Hour Free Legal Consultation)',
  'Testing and Certification',
  'Marketing Services',
  // 'Business Services',
  // 'Banking',
  // 'Insurance',
  // 'Film Industry',
];

export default categoryEn;
